export const getUniqueStatusColor = (label) => {

  const colorCodes = {
    "All": "#536493",
    "In Progress": "#6F6EDE",
    "Action Required": "#F26666",
    "Requested Follow Up": "#FABC3F",
    "Qualified": "#15B392",
    "Booked": "#66D062",
    "DNQ Criteria Not Met": "#CBA35C",
    "DNQ Other": "#CBA35C",
    "DNQ No Response": "#CBA35C",
    "DNQ Not Interested": "#CBA35C",
    "Non-textable": "#D73A60",
    "To-call": "#605EA1",
    "Contact Attempt 1": "#F28E58",
    "Contact Attempt 2": "#F28E58",
    "Contact Attempt 3": "#F28E58",
    "Scheduled Screen": "#AA5486",
    "Skipped": "#B91C1C",
  };
  
  return colorCodes[label] || "#536493";
};